import { render } from "./Section6View.vue?vue&type=template&id=85ac49b4&scoped=true"
import script from "./Section6View.vue?vue&type=script&lang=js"
export * from "./Section6View.vue?vue&type=script&lang=js"

import "./Section6View.vue?vue&type=style&index=0&id=85ac49b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ac49b4"]])

export default __exports__